import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentGroup } from "../store/groups";
import { getPlay } from "../store/play";
import PlayLoader from "./hoc/playLoader";
import StartLoader from "./hoc/startLoader";
import LocationLoader from "./hoc/locationLoader";
import { getStartByPlayId } from "../store/start";
import { getJobById } from "../store/job";
import JobBlock from "./JobBlock";
import LocationComponent from "../ui/LocationComponent";
import LocationCheck from "../ui/LocationCheck";
import { useI18n } from "../i18n/LanguageContext";

const Job = (props) => {
  const dispatch = useDispatch();
  const { t } = useI18n();
  const { missionId } = useParams();
  const group = useSelector(getCurrentGroup());
  const start = useSelector(getStartByPlayId(group && group.playId));
  const play = useSelector(getPlay(group && group.playId));
  const [show, setShow] = useState(false);

  const handleJob = useCallback(() => {
    setShow(true);
    play &&
      start &&
      dispatch(getJobById(play.tasks[start.number], play.job[start.number]));
  }, [play, start]);

  const handleShow = () => {
    setShow(false);
  };

  if (group && missionId !== group.missionId) {
    return (
      <div className="flex justify-center font-extrabold text-xl py-20 w-full h-full">
        <div className="bg-black text-white p-10 rounded-lg">
          {t("job.notInGame")}
        </div>
      </div>
    );
  } else {
    return (
      <PlayLoader>
        <StartLoader>
          <LocationLoader>
            <div className="w-full flex justify-end my-5 px-5">
              <LocationComponent />
            </div>

            <div className="container w-full h-full text-lg">
              <div className="bg-gray-100">
                <p className="text-red-400 px-3 md:px-20 mt-10">
                  {t("job.onlyAtPoint")}
                </p>
              </div>
              {show ? (
                <div className="flex md:mx-5 lx:mx-40 my-20 p-5  bg-yellow-100">
                  <JobBlock
                    handleShow={handleShow}
                    taskId={play?.tasks[start.number]}
                    jobId={play?.job[start.number]}
                  />
                </div>
              ) : (
                <div className="flex justify-center py-10">
                  <div>
                    <LocationCheck handleJob={handleJob} />
                  </div>
                </div>
              )}
              <div className="mx-5 md:mx-20">
                <ul className="list-disc">
                  {Array.from({ length: 7 }, (_, index) => (
                    <li key={index}>{t(`job.l${index + 1}`)}</li>
                  ))}
                </ul>
              </div>
            </div>
          </LocationLoader>
        </StartLoader>
      </PlayLoader>
    );
  }
};

Job.propTypes = {};

export default Job;
